import(/* webpackMode: "eager" */ "/codebuild/output/src2441318530/src/witmetrics-insights/src/app/layout.tsx")